var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1Br(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 307,
    viewBox: "0 0 449 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M396.854 155.44L320.766 83.3633L303.875 308.36L80.1223 337.403L156.211 409.479L379.964 380.437L396.854 155.44Z",
    fill: "#D9166F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.583 112.61L373.641 0.886719L347.466 349.646L0.625113 394.667L118.567 506.39L465.408 461.369L491.583 112.61Z",
    fill: "url(#paint0_radial_16581_556)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16581_556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.591 328.934) rotate(43.4488) scale(165.159 332.17)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1Br);
export default __webpack_public_path__ + "static/media/shape1BR.6f521881b9fb38e0b76e2e20dc53877b.svg";
export { ForwardRef as ReactComponent };